import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomScrollDirective, DefaultImageDirective, DndDirective} from "./directives";
import {NgMaterialModule} from "../ng-material/ng-material.module";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {StatusDirective} from './directives';
import {NgxCaptureModule} from "ngx-capture";
import {
  CodeInputComponent,
  DataRoomComponent,
  DealCardComponent,
  DeleteConfirmationModalComponent,
  HistoryComponent,
  IframeThumbnailComponent,
  NotepadComponent,
  TimelineComponent,
  ConfirmationModalComponent,
  UserCardComponent,
  BusinessUnitCardComponent,
  UserCardModalComponent,
  PermissionCheckComponent,
  DateDisplayComponent,
  PromptModalComponent,
  InterestedInDealModalComponent
} from "./components";
import {DataRoomService, DocumentsService, HistoryService, UtilService} from "./services";
import {FileSizePipe} from "./pipes/file-size.pipe";
import {ImageCropperModule} from "ngx-image-cropper";
import {DragDropModule} from "@angular/cdk/drag-drop";
import { PermissionDirective } from 'src/app/modules/shared/directives/permission.directive';
import { DisableButtonDirective } from './directives/disable-button.directive';
import { PreviewComponent } from './components/preview/preview.component';
import { EmailHistoryDialogComponent } from './components/email-history-dialog/email-history-dialog.component';
import { EmailBodyDialogComponent } from './components/email-body-dialog/email-body-dialog.component';

@NgModule({
  declarations: [
    DealCardComponent,
    TimelineComponent,
    DefaultImageDirective,
    NotepadComponent,
    DndDirective,
    StatusDirective,
    DeleteConfirmationModalComponent,
    IframeThumbnailComponent,
    DataRoomComponent,
    CustomScrollDirective,
    CodeInputComponent,
    FileSizePipe,
    HistoryComponent,
    ConfirmationModalComponent,
    UserCardComponent,
    BusinessUnitCardComponent,
    UserCardModalComponent,
    PermissionCheckComponent,
    DateDisplayComponent,
    PromptModalComponent,
    PreviewComponent,
    InterestedInDealModalComponent,

    PermissionDirective,
    DisableButtonDirective,
    EmailHistoryDialogComponent,
    EmailBodyDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgMaterialModule,
    NgxCaptureModule,
    ImageCropperModule,
    DragDropModule,
  ],
  providers: [
    // KycService,
    DataRoomService,
    DocumentsService,
    // KycDocumentService,
    UtilService,
    HistoryService
  ],
  exports: [
    DealCardComponent,
    TimelineComponent,
    DefaultImageDirective,
    NotepadComponent,
    DndDirective,
    StatusDirective,
    DeleteConfirmationModalComponent,
    IframeThumbnailComponent,
    DataRoomComponent,
    CustomScrollDirective,
    CodeInputComponent,
    FileSizePipe,
    HistoryComponent,
    ConfirmationModalComponent,
    UserCardComponent,
    BusinessUnitCardComponent,
    PermissionCheckComponent,
    PermissionDirective,
    DisableButtonDirective,
    InterestedInDealModalComponent
  ]
})
export class SharedModule {
}
